import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type StatusFilterCashTransferValue = 'all' | 'toBeProcessed' | 'treaties';

type RootAuthorisationsState = {
  mainFilters: {
    status: StatusFilterCashTransferValue;
  };
};
const initialState: RootAuthorisationsState = {
  mainFilters: {
    status: 'toBeProcessed',
  },
};

export const cashTransferFilterSlice = createSlice({
  name: 'filterCashTransfer',
  initialState,
  reducers: {
    statusChanged: (
      state,
      { payload }: PayloadAction<{ status: StatusFilterCashTransferValue }>,
    ) => {
      state.mainFilters.status = payload.status;
    },
  },
  selectors: {
    status: (state) => state.mainFilters.status,
  },
});

export const filterCashTransferSelectors = cashTransferFilterSlice.selectors;
export const filterCashTransferActions = cashTransferFilterSlice.actions;
